import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import TextareaAutosize from 'react-autosize-textarea';

export interface TextInputProps {
    onChange;
    invalid;
    name;
    type?;
    value?;
    rows?;
    autoResize?;
}

@observer export class TextArea extends Component<TextInputProps, any> {

    render() {
        const { invalid, onChange, name, type, value, rows, autoResize } = this.props;
        const TA = TextareaAutosize as any;

        if (autoResize) {
            return <TA
                name={name}
                rows={rows}
                className={'form-control'}
                defaultValue={value}
                onChange={e => onChange(e.currentTarget.value)}
            />
        }

        return <textarea
            name={name}
            rows={rows}
            className={'form-control'}
            defaultValue={value}
            onChange={e => onChange(e.currentTarget.value)}
        ></textarea>
    }

}
